import React from "react";
import { Wallet } from "lucide-react";
import { t } from "../../utils/i18n";

// Seule touche dorée de toute la fonctionnalité Date — un liseré discret, jamais une couleur
// dominante, pour rappeler la règle financière ("qui invite paie") sans jamais ressembler à
// une alerte ou à une promotion.
export default function PayRuleCallout({ lang, variant = "inviter" }: { lang: string; variant?: "inviter" | "invitee" }) {
  return (
    <div style={{
      display: "flex", alignItems: "flex-start", gap: 10, padding: 14, borderRadius: 14,
      backgroundColor: "#faf8f3", border: "1px solid #eee5d0", marginBottom: 4,
    }}>
      <Wallet size={16} color="#b8952e" style={{ flexShrink: 0, marginTop: 1 }} />
      <div style={{ fontSize: 12.5, color: "#6b5d38", lineHeight: 1.5 }}>
        {variant === "inviter" ? (
          <>
            <div style={{ fontWeight: 700 }}>{t(lang, "date_pay_rule_inviter")}</div>
            <div>{t(lang, "date_pay_rule_invitee")}</div>
          </>
        ) : (
          <div style={{ fontWeight: 700 }}>{t(lang, "date_pay_you_pay_nothing")}</div>
        )}
      </div>
    </div>
  );
}
